import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from './user.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {



    constructor(private _httpClient: HttpClient) { }


    getUser(id: number): Observable<User>{
        return this._httpClient.get<User>('/ypm/api/fm/user/' + id);
    }

    guardarUser(user: User): Observable<User>{
        return this._httpClient.post<User>('/ypm/api/fm/user' , user);
    }

    deleteUser(user: User): Observable<User> {
        return this._httpClient.delete<User>('/ypm/api/fm/user/' + user.id);
    }
}
